import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { I, IIcon } from 'common/src/designSystem/components/i';
import * as React from 'react';
import { useHeavent } from '../../hooks/useHeavent';

interface IOmnibarRowProps {
    avatar?: React.ReactNode;
    children: React.ReactNode;
    icon?: IIcon;
    link: string;

    onClose(): void;
}

export const OmnibarRow = (props: IOmnibarRowProps) => {
    const { history } = useHeavent();

    return (
        <Flex
            align="center"
            css={{
                cursor: 'pointer',
                px: '$4',
                '&:hover': {
                    background: '$gray100'
                }
            }}
            gap="2"
            height={40}
            onClick={() => {
                history.push(props.link);
                props.onClose();
            }}
        >
            {props.avatar}

            {props.icon && (
                <Box color="gray500" fontSize="textXs">
                    <I icon={props.icon} />
                </Box>
            )}

            <Box font="gray800 textSm medium">{props.children}</Box>
        </Flex>
    );
};
